import get from 'lodash/get';
import { request } from 'client/modules/common/utils/request';
import { logInfo } from 'client/modules/common/utils/logInfo';
import { setToastError } from 'client/modules/third-party-admin/profile-queue/utils';

interface RecordDealOutcomeArgs {
  idNewsDeal: number;
  outcome: number; // DEAL_OUTCOME (1=PUBLISHED, 2=REJECTED, 3=SKIPPED)
  idFunding?: number;
}

export function recordDealOutcome({
  idNewsDeal,
  outcome,
  idFunding = 0,
}: RecordDealOutcomeArgs): Promise<boolean> {
  return request({
    url: '/service/newsqueueservice/RecordDealReviewOutcome',
    body: { idNewsDeal, outcome, idFunding },
  })
    .then(({ body }) => Boolean(get(body, 'success', false)))
    .catch((error) => {
      setToastError('Error Recording Deal Outcome');
      logInfo({
        error,
        message: 'Deal Queue: Failed To Record Outcome',
        method: 'recordDealOutcome',
      });
      throw error;
    });
}
